export default function getContext() {
  // eslint-disable-next-line no-undef
  return typeof window === 'undefined' ? context : window;
}
